import { create } from 'zustand';
import { getNotificationSettingsFromLocalStorage } from '../lib/local-storage';
import createSetter from './utils';

interface NotificationLookup {
	[chatroomKey: string]: Date;
}

interface NotificationSettings {
	[setting: string]: {
		enabled: boolean;
		label: string;
	};
}

const DEFAULT_SETTINGS: NotificationSettings = {
	newMessages: {
		enabled: true,
		label: 'New Chat Messages',
	},
	// newOrders: {
	//     enabled: false,
	//     label: 'New Orders',
	// },
};

interface NotificationsState {
	notifications: NotificationLookup;
	setNotifications: (notifications: NotificationLookup) => void;
	settings: NotificationSettings;
	setSettings: (settings: NotificationSettings) => void;
}

const useNotifications = create<NotificationsState>((set, get) => ({
	notifications: {},
	settings: getNotificationSettingsFromLocalStorage() || DEFAULT_SETTINGS,
	setNotifications: createSetter<NotificationsState>(set, get, 'notifications'),
	setSettings: createSetter<NotificationsState>(set, get, 'settings'),
}));

export default useNotifications;
